/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const UserGroupIcon = createIcon(
  '0 0 20 20',
  <g>
    <path d="M12 2a4 4 0 0 0-.516 7.967q.015.003.016.018-.002.016-.018.019A7 7 0 0 0 5.387 14c-.426.9-.723 1.869-1.018 2.83-.12.393-.24.785-.369 1.17h16c-.128-.385-.248-.776-.369-1.17-.295-.96-.592-1.93-1.018-2.83a7 7 0 0 0-6.095-3.996.02.02 0 0 1-.018-.019q.001-.015.016-.018A4 4 0 0 0 12 2" />
    <path d="M6.602 3.39A5.8 5.8 0 0 0 6 5.939c0 1.2.353 2.382 1 3.39-2.57 1.748-3.448 3.35-4.456 6.672H0l.735-2.205C1.49 11.53 3.611 9.328 6 9.328a3 3 0 1 1 0-6c.195 0 .417.027.602.063" />
  </g>,
);
